export const PrivacyPolicy = () => {
  return (
    <div className="content text-justify text-black text-lg md:text-xl px-4 mx-auto my-6 md:my-8">
      <div className="text-xl md:text-2xl font-medium mt-4">
        隱私權及安全政策
      </div>
      <div className="mt-12 font-medium">
        高雄市政府教育局雙語暨數位學習推動辦公室（以下簡稱本辦），特別在此聲明本辦網站隱私權維護的所有細節，藉以讓所有瀏覽本局網站的所有用戶都能了解我們的隱私權保護條例。
      </div>
      <ol className="list-decimal list-inside flex flex-col gap-5 mx-4 md:mx-6 mt-12">
        <li>
          適用範圍： 以下的隱私保護及網站安全政策，適用於您在本辦網站所涉及的活動，但不適用於在本辦網站置設之其他網站連結，當您點選連結至其他網站時，適用各該網站的隱私保護及網站安全政策。
        </li>
        <li>
          本辦網站對於使用者的個人資料收集，謹遵守中華民國「電腦處理個人資料保護法」之規定，未經許可及使用者同意，本辦不會任意蒐集使用者個人資料。
        </li>
        <li>
          本辦網站中所有網頁資料（含文字檔及圖檔），著作權皆屬於本辦所有，如需連結或引用，請以電子郵件方式告知本辦，並註明出處；如為本辦連結至辦外之網頁，請先徵求該單位之同意，並註明出處。
        </li>
        <li>
          瀏覽本辦網站主頁，不必輸入個人資料。
        </li>
        <li>
          教師認證系統：使用本辦網站相關系統時，須登入使用者帳號及密碼。
          當使用者為高雄市所屬機關學校教職員，各機關人事主管會將使用者之相關資料（如姓名、身分證號碼、E-mail、住址及電話等個人資訊等）登錄於人事管理系統，因此教師的OpenID作為本網站相關系統登入時身份確認之用。
          本辦不會出售、轉讓或洩漏任何教師相關資訊與其他非教育單位，並且嚴禁內部人員私自使用該資料。
          建議教師在完成工作後退出身份並關閉瀏覽器視窗。這樣，使用者才能在與他人共享電腦或在圖書館、網吧之類的公共場所使用電腦時，確保他人無法讀取閣下的個人資料。
        </li>
        <li>
          在部分情況下，本辦網站使用通行標準的SSL保全系統，保障資料傳送的安全性。
        </li>
      </ol>
      <div className="mt-12 font-medium">
        上述隱私權政策宣告自即日起生效，未來如因法令規定或社會變遷等因素，本辦為加強尊重保護使用者的隱私，有權修改本宣告，並儘速更新與公告。
      </div>
      <div className="p-7 lg:p-16"></div>
    </div>
  )
}